import { render, staticRenderFns } from "./LostcomConfirmContent.vue?vue&type=template&id=29c32053&"
import script from "./LostcomConfirmContent.vue?vue&type=script&lang=js&"
export * from "./LostcomConfirmContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports